(function(){
  function nameFrom(t){
    var parts = t.split('|').map(function(s){ return s.trim(); });
    if(parts.length >= 3) return parts[1];
    return parts[0].replace(/\s+(Perfume|Cologne)(\s+for\s+(Men|Women))?$/i, '');
  }
  function shortTitles(){
    document.querySelectorAll('.card__heading a, .card__heading, .predictive-search__item-heading, .cart-item__name, .cart-notification-product__name').forEach(function(el){
      if(el.dataset.mdpShort) return;
      if(el.matches('.card__heading') && el.querySelector('a')) return;
      var t = el.textContent;
      if(t.indexOf('|') === -1) return;
      el.dataset.mdpShort = '1';
      el.title = t.trim();
      el.textContent = nameFrom(t);
    });
  }
  function shippingNotes(){
    document.querySelectorAll('.product__tax').forEach(function(el){
      if(el.dataset.mdpShip) return; el.dataset.mdpShip = '1';
      el.textContent = 'Free shipping to Canada & the USA.';
    });
    document.querySelectorAll('.tax-note').forEach(function(el){
      if(el.dataset.mdpShip) return; el.dataset.mdpShip = '1';
      el.textContent = 'Free shipping to Canada & the USA. Taxes calculated at checkout.';
    });
  }
  function run(){ shortTitles(); shippingNotes(); }
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });

  /* Keep each free gold name label tied to its personalised bottle in the cart */
  var LABEL_VARIANT = 51473004789929, busy = false;
  function reconcile(){
    if(busy || location.pathname.indexOf('/cart') !== 0) return;
    busy = true;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var changes = [];
      c.items.forEach(function(it){
        if(it.variant_id !== LABEL_VARIANT) return;
        var nm = it.properties && it.properties['Name'];
        var qty = c.items.filter(function(b){ return b.variant_id !== LABEL_VARIANT && b.properties && b.properties['Name on label'] === nm; }).reduce(function(s, b){ return s + b.quantity; }, 0);
        if(qty !== it.quantity) changes.push({ id: it.key, quantity: qty });
      });
      if(!changes.length){ busy = false; return; }
      return changes.reduce(function(p, ch){ return p.then(function(){ return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(ch) }); }); }, Promise.resolve()).then(function(){ location.reload(); });
    }).catch(function(){ busy = false; });
  }
  document.addEventListener('DOMContentLoaded', reconcile);
  setInterval(reconcile, 2000);
})();
